import { render, staticRenderFns } from "./TipHandle.vue?vue&type=template&id=219b4d48&scoped=true&"
import script from "./TipHandle.vue?vue&type=script&lang=js&"
export * from "./TipHandle.vue?vue&type=script&lang=js&"
import style0 from "./TipHandle.vue?vue&type=style&index=0&id=219b4d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b4d48",
  null
  
)

export default component.exports